import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Profile information")
], -1)
const _hoisted_3 = { class: "card-body bg-light" }
const _hoisted_4 = { class: "row mb-3" }
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "profile-title"
}, "Title", -1)
const _hoisted_7 = ["selected"]
const _hoisted_8 = ["selected"]
const _hoisted_9 = ["selected"]
const _hoisted_10 = ["selected"]
const _hoisted_11 = ["selected"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "profile-account-type"
}, "Account Type", -1)
const _hoisted_20 = ["selected"]
const _hoisted_21 = ["selected"]
const _hoisted_22 = ["selected"]
const _hoisted_23 = ["selected"]
const _hoisted_24 = ["textContent"]
const _hoisted_25 = { class: "row mb-3" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "row mb-3" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "row mb-3" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "row mb-3" }
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "row mb-3" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = ["textContent"]
const _hoisted_42 = { class: "card" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Change Password")
], -1)
const _hoisted_44 = { class: "card-body bg-light" }
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "register-form",
          onSubmit: _ctx.processForm,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  id: "profile-title",
                  name: "title",
                  label: "Title",
                  class: "form-select",
                  as: "select",
                  placeholder: _ctx.$t('profile.title'),
                  value: "mr",
                  "aria-label": "Select Title"
                }, {
                  default: _withCtx(({ value }) => [
                    _createElementVNode("option", {
                      value: "",
                      disabled: "",
                      selected: value
                    }, "Select Title", 8, _hoisted_7),
                    _createElementVNode("option", {
                      value: "mr",
                      selected: value
                    }, "Mr.", 8, _hoisted_8),
                    _createElementVNode("option", {
                      value: "mrs",
                      selected: value
                    }, "Mrs.", 8, _hoisted_9),
                    _createElementVNode("option", {
                      value: "ms",
                      selected: value
                    }, "Ms.", 8, _hoisted_10),
                    _createElementVNode("option", {
                      value: "miss",
                      selected: value
                    }, "Miss", 8, _hoisted_11)
                  ]),
                  _: 1
                }, 8, ["placeholder"]),
                _createElementVNode("div", {
                  class: "text-danger text-sm",
                  textContent: _toDisplayString(errors.title)
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Input, {
                  id: "profile-first-name",
                  label: "First Name*",
                  name: "firstName",
                  placeholder: _ctx.$t('profile.first-name'),
                  error: errors.firstName,
                  value: "Gabriel"
                }, null, 8, ["placeholder", "error"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Input, {
                  id: "profile-last-name",
                  label: "Last Name*",
                  name: "lastName",
                  placeholder: _ctx.$t('profile.last-name'),
                  error: errors.lastName,
                  value: "Diaz"
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Input, {
                  id: "profile-email",
                  label: "Email*",
                  name: "email",
                  placeholder: _ctx.$t('profile.email'),
                  error: errors.email,
                  value: "gabrieldiaz31@gmail.com"
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  id: "profile-account-type",
                  name: "accountType",
                  class: "form-select",
                  as: "select",
                  placeholder: _ctx.$t('register.type'),
                  value: "business",
                  "aria-label": "Select account type"
                }, {
                  default: _withCtx(({ value }) => [
                    _createElementVNode("option", {
                      value: "",
                      disabled: "",
                      selected: value
                    }, " Select account type ", 8, _hoisted_20),
                    _createElementVNode("option", {
                      value: "business",
                      selected: value
                    }, "Business", 8, _hoisted_21),
                    _createElementVNode("option", {
                      value: "school",
                      selected: value
                    }, "School", 8, _hoisted_22),
                    _createElementVNode("option", {
                      value: "freelancer",
                      selected: value
                    }, "Freelancer", 8, _hoisted_23)
                  ]),
                  _: 1
                }, 8, ["placeholder"]),
                _createElementVNode("div", {
                  class: "text-danger text-sm",
                  textContent: _toDisplayString(errors.type)
                }, null, 8, _hoisted_24)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_Input, {
                  id: "profile-business-name",
                  label: "Business Name",
                  name: "businessName",
                  placeholder: _ctx.$t('profile.business-name'),
                  error: errors.businessName,
                  value: "Latudio"
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_Input, {
                  id: "profile-business-address",
                  label: "Business Address",
                  name: "businessAddress",
                  placeholder: _ctx.$t('profile.business-address'),
                  error: errors.businessAddress,
                  value: "123 Main St."
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Input, {
                  id: "profile-country",
                  label: "Country",
                  name: "country",
                  placeholder: _ctx.$t('profile.country'),
                  error: errors.country,
                  value: "Unites States"
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_Input, {
                  id: "profile-state",
                  label: "State (US only)",
                  name: "state",
                  placeholder: _ctx.$t('profile.state'),
                  error: errors.state,
                  value: "Texas"
                }, null, 8, ["placeholder", "error"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_Input, {
                  id: "profile-city",
                  label: "City",
                  name: "city",
                  placeholder: _ctx.$t('profile.city'),
                  error: errors.city,
                  value: "San Jose"
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_Input, {
                  id: "profile-zipcode",
                  label: "Zipcode",
                  name: "zipcode",
                  placeholder: _ctx.$t('profile.zipcode'),
                  error: errors.zipcode,
                  value: "12345"
                }, null, 8, ["placeholder", "error"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_Input, {
                  id: "profile-phoneNumber",
                  label: "Phone Number",
                  name: "phoneNumber",
                  placeholder: _ctx.$t('profile.phone-number'),
                  error: errors.phoneNumber,
                  value: "+1 123-456-7890"
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_Input, {
                  id: "profile-business-license-number",
                  label: "Business License Number",
                  name: "businessLicenseNumber",
                  placeholder: _ctx.$t('profile.business-license-number'),
                  error: errors.businessLicenseNumber,
                  value: ""
                }, null, 8, ["placeholder", "error"])
              ])
            ]),
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                class: "btn btn-primary d-block w-100 mt-3",
                type: "submit",
                name: "submit",
                textContent: _toDisplayString('Update Information')
              }, null, 8, _hoisted_41)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_Form, {
          id: "profile-password-form",
          onSubmit: _ctx.processPasswordForm,
          "validation-schema": _ctx.passwordSchema
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_Input, {
                id: "old-password",
                label: "Old Password",
                name: "old-password",
                type: "password",
                placeholder: _ctx.$t('old.password'),
                error: errors.password
              }, null, 8, ["placeholder", "error"])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_Input, {
                id: "profile-password",
                label: "New Password",
                name: "password",
                type: "password",
                placeholder: _ctx.$t('profile.password'),
                error: errors.password
              }, null, 8, ["placeholder", "error"])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_Input, {
                id: "profile-confirm-password",
                label: "Confirm Password",
                name: "confirmPassword",
                type: "password",
                placeholder: _ctx.$t('profile.confirm-password'),
                error: errors.confirmPassword
              }, null, 8, ["placeholder", "error"])
            ]),
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                class: "btn btn-primary d-block w-100 mt-3",
                type: "submit",
                name: "submit",
                textContent: _toDisplayString('Update Password')
              }, null, 8, _hoisted_50)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 64))
}